export const appConstants = {
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    LOGGED_IN: 'loggedIn',
    PROFILE_INFO: 'profileInfo',
    REMEMBER_ME: 'rememberMe',
    USER_ID: 'user_id',
    EMAIL: 'email',
    LANGUAGE: 'language'
}